import speedTest_component from 'CY/components/speedTest/speedTest.component';
import SecurityCenter_component from '#BASE/components/accountInfo/SecurityCenter';

export default {
    mixins: [speedTest_component],
    components: {
        SecurityCenter_component
    },
    methods: {
        async checkgoLink(url) {
            let _result = await this.$dialog.confirm("是否切换线路？");
            if (_result.state) {
                this.goLink(url);
            }
        },
    },
};